import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { StatisticsContainer, Overlay } from "./styles"
import { Row, Col } from "react-bootstrap"
import BackgroundImage from "gatsby-background-image"
import { renderHTML } from "../../agility/utils"

const IMAGES_QUERY = graphql`
  query {
    allAgilityStatistics {
      nodes {
        customFields {
          leftImageLocalImg {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
          rightImageLocalImg {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }
  }
`

const Statistics = ({ item }) => {
  const data = useStaticQuery(IMAGES_QUERY)
  return (
    <StatisticsContainer>
      <Row>
        <div className="title">
          <h2>{item.customFields.title}</h2>
        </div>
        <Col lg={6} md={6} sm={6}>
          <BackgroundImage
            className="masthead"
            fluid={
              data.allAgilityStatistics.nodes[0].customFields.leftImageLocalImg
                .childImageSharp.fluid
            }
          >
            <Overlay>
              <div
                className="image-text"
                dangerouslySetInnerHTML={renderHTML(item.customFields.leftText)}
              />
            </Overlay>
          </BackgroundImage>
        </Col>
        <Col lg={6} md={6} sm={6}>
          <BackgroundImage
            className="masthead"
            fluid={
              data.allAgilityStatistics.nodes[0].customFields.rightImageLocalImg
                .childImageSharp.fluid
            }
          >
            <Overlay>
              <div
                className="image-text"
                dangerouslySetInnerHTML={renderHTML(
                  item.customFields.rightText
                )}
              />
            </Overlay>
          </BackgroundImage>
        </Col>
      </Row>
    </StatisticsContainer>
  )
}

export default Statistics
